<template>
    <div class="company-list">
        <div v-for="company of companiesToShow" :key="company.id" class="company-list-item">
            <span class="material-symbols-outlined company-list-item-value" @click="editCompany(company)">
                contract_edit
            </span>
            <span class="material-symbols-outlined company-list-item-value" @click="deleteCompanyNotes(company)">
                contract_delete
            </span>
            <span class="material-symbols-outlined company-list-item-value" @click="removeCompanyFromGroup(company.id)">
                delete
            </span>
            <span class="company-name">{{ company.name }}</span>
            <span v-if="settingsStore.debugMode">&nbsp;({{ company.id }})</span>
            <span v-if="compUtils.hasNotes(company)">
                <!-- &#8212 is long dash -->
                &nbsp;&nbsp;&#8212;&nbsp;&nbsp;{{ compUtils.getAbbreviatedNotes(company) }}
            </span>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineExpose, inject, ref, computed } from 'vue';
    import { Modal as ModalLib, promptModal } from 'jenesius-vue-modal';
    import { useCompanyStore } from '@/stores/CompanyStore';
    import { useSettingsStore } from '@/stores/SettingsStore';
    import { CompanyUtils } from '@/lib/CompanyUtils';
    import EditCompany from '../components/EditCompany.vue';

    const props = defineProps({
        companies: {
            type: Array,
            required: true
        },

        allowDelete: {
            type: Boolean,
            default: false
        }
    });

    const api = inject('api');
    const companyStore = useCompanyStore();
    const settingsStore = useSettingsStore();
    const compUtils = new CompanyUtils();
    const removedCompanies = ref([]);
    const removedNotes = ref([]);

    defineExpose({
        removedCompanies,
        removedNotes
    });

    async function editCompany(company) {
        const res = await promptModal(EditCompany, { company, allowHide: false, allowBlock: false });

        if (res) {
            try {
                // they have saved the company, so get an updated version from the api
                const res = await api.getCompany(company.id);
                compUtils.fillNotes(res.data, company);
            }
            catch (err) {
                promptModal(Error, { message: 'Error refreshing data company data during parent creation', details: err.stack });
            }
        }
    }

    async function deleteCompanyNotes(company) {
        await companyStore.updateCompanyNotes2(company, '');
    }

    function removeCompanyFromGroup(companyId) {
        removedCompanies.value.push(companyId);
    }

    function hasBeenRemoved(company) {
        return !!removedCompanies.value.find(id => id === company.id);
    }

    const companiesToShow = computed(() => {
        return props.companies.filter(c => !hasBeenRemoved(c));
    });
</script>

<style scoped>
    .company-list {
        max-height: 200px;
        margin-top: 5px;
        overflow: scroll;
    }

    .company-list .company-list-item {
        display: flex;
        flex-direction: row;
        align-items: end;
        justify-content: left;
        height: 35px;
    }

    .company-list .company-list-item .company-list-item-value {
        margin-right: 10px;
        cursor: pointer;
    }
</style>
